export enum DepositType {
  CashCollection,
  Bank,
  HandOver,
  MobileMoneyCollection,
  Expenses,
  Purchases,
  Other,
}
